const Btcd = {
  symbol: 'btcd',
  color: '#000',
  plainIcon: c => {
    return `<path fill="${
      c ? c : this.color
    }" d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm1.078-12.644c.908 1.422 1.345 4.4 1.268 5.467C30.31 20.71 26.562 7.567 18.586 7c0 2.945-.678 5.322-1.508 5.322 3.267.2 5.08 5.467 0 7.034zM6 17.8c5.954 0 10.773-4.823 10.773-10.79h-5.561c.01 2.923-2.317 5.312-5.201 5.323H6V17.8zm7.287-.99c-1.507 1.357-2.349 2.057-6.478 2.723 2.436 0 4.403 2.445 4.403 5.467h5.56c0-.911-.185-5.478-3.485-8.19z"/>`;
  },
  colorIcon() {
    return `<g fill="none"><circle cx="16" cy="16" r="16" fill="#F60"/><path fill="#FFF" d="M17.078 19.356c5.08-1.567 3.267-6.834 0-7.034.83 0 1.508-2.377 1.508-5.322 7.976.567 11.723 13.711-.24 17.823.077-1.067-.36-4.045-1.267-5.467zM6 17.8v-5.467h.01c2.885-.011 5.212-2.4 5.202-5.322h5.56C16.773 12.977 11.955 17.8 6 17.8zm7.287-.99c3.3 2.712 3.486 7.279 3.486 8.19h-5.561c0-3.022-1.967-5.467-4.403-5.467 4.13-.666 4.971-1.366 6.478-2.722z"/></g>`;
  }
};
export default Btcd;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-cryptoicon/src/icons/btcd.js
// module id = null
// module chunks = 